/* global window */
'use strict';

module.exports = require('./ponyfill')(global || window || this);



/*****************
 ** WEBPACK FOOTER
 ** ./~/redux/~/symbol-observable/index.js
 ** module id = 1369
 ** module chunks = 1
 **/